import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-timepicker/dist/index.module.css';
const TimepickerBody = _ref => {
  let {
    children
  } = _ref;
  const timePickerBodyClasses = classNames({
    [styles['sib-timepicker-mainBody']]: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: timePickerBodyClasses
  }, children);
};
TimepickerBody.propTypes = {
  children: PropTypes.node.isRequired
};
export default TimepickerBody;